import { pick } from "lodash-es";

import Address from "@mapmycustomers/shared/types/Address";

const addressToSavedAddressFields = (address: Address) =>
  pick(address, [
    "address",
    "city",
    "country",
    "countryCode",
    "postalCode",
    "region",
    "regionCode",
  ]);

export default addressToSavedAddressFields;
